import { CustomSelect } from '../../common/CustomSelect';

export default function LeadExportDialog({
  isOpen,
  isExporting,
  exportLoadingText,
  exportDateError,
  todayDate,
  exportFromDate,
  onFromDateChange,
  exportToDate,
  onToDateChange,
  exportReportType,
  onReportTypeChange,
  reportConfig,
  selectedExportReport,
  renderExportFilter,
  exportDownloadFormat,
  setExportDownloadFormat,
  onExport,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={() => {
        if (isExporting) return;
        onClose();
      }}
    >
      <div
        className="w-full max-w-2xl rounded-2xl bg-white p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <div className="space-y-1">
            <label className="text-sm text-gray-700">From</label>
            <input
              type="date"
              max={todayDate}
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
              value={exportFromDate}
              onChange={(e) => onFromDateChange(e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm text-gray-700">To</label>
            <input
              type="date"
              min={exportFromDate || undefined}
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#005787]"
              value={exportToDate}
              onChange={(e) => onToDateChange(e.target.value)}
            />
          </div>
        </div>

        {exportDateError && (
          <p className="mt-2 text-sm text-red-600">{exportDateError}</p>
        )}

        <div className="mt-4 space-y-1">
          <label className="text-sm text-gray-700">
            Category / Format <span className="text-red-500">*</span>
          </label>
          <CustomSelect
            options={reportConfig.map((report) => ({
              label: report.label,
              value: report.reportType,
            }))}
            value={exportReportType}
            onChange={onReportTypeChange}
            placeholder="Category / Format"
          />
        </div>

        {selectedExportReport?.filters?.length > 0 && (
          <div className="mt-4 grid grid-cols-1 gap-3">
            {selectedExportReport.filters.map((filterName) => (
              <div key={filterName} className="space-y-1">
                {filterName === 'countries' && (
                  <label className="text-sm text-gray-700">Countries</label>
                )}
                {filterName === 'agents' && (
                  <label className="text-sm text-gray-700">Agents</label>
                )}
                {filterName === 'status' && (
                  <label className="text-sm text-gray-700">Status</label>
                )}
                {filterName === 'visaCategory' && (
                  <label className="text-sm text-gray-700">
                    Visa Category
                  </label>
                )}
                {filterName === 'matchField' && (
                  <label className="text-sm text-gray-700">Match Field</label>
                )}
                {filterName === 'days' && (
                  <label className="text-sm text-gray-700">No. of Days</label>
                )}
                {filterName === 'biometricFromDate' && (
                  <label className="text-sm text-gray-700">
                    Biometric From Date
                  </label>
                )}
                {filterName === 'biometricToDate' && (
                  <label className="text-sm text-gray-700">
                    Biometric To Date
                  </label>
                )}
                {renderExportFilter(filterName)}
              </div>
            ))}
          </div>
        )}

        <div className="mt-5 flex items-center justify-end gap-3">
          <div className="inline-flex overflow-hidden rounded-full border border-gray-300 bg-white">
            <button
              type="button"
              onClick={() => setExportDownloadFormat('csv')}
              disabled={isExporting}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                exportDownloadFormat === 'csv'
                  ? 'bg-[#005787] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              } disabled:cursor-not-allowed disabled:opacity-70`}
            >
              CSV
            </button>
            <button
              type="button"
              onClick={() => setExportDownloadFormat('pdf')}
              disabled={isExporting}
              className={`border-l border-gray-300 px-4 py-2 text-sm font-medium transition-colors ${
                exportDownloadFormat === 'pdf'
                  ? 'bg-[#005787] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              } disabled:cursor-not-allowed disabled:opacity-70`}
            >
              PDF
            </button>
          </div>
          <button
            type="button"
            onClick={onExport}
            disabled={isExporting || !exportReportType}
            className="rounded-full bg-[#87CA60] px-5 py-2 text-sm font-medium text-black hover:bg-[#72b34d] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isExporting ? exportLoadingText : 'Export'}
          </button>
        </div>
      </div>
    </div>
  );
}